import { LayoutState } from '../Interfaces/layouts.interface';
import { LayoutActionTypes } from '../Constants/Types';

const initialState: LayoutState = {
  layouts: [],
  layout: null,
  llayouts: false,
  llayout: false,
  pages: 0
};

const LayoutsReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case LayoutActionTypes.LOADING_LAYOUTS:
      return { ...state, llayouts: true };
    case LayoutActionTypes.GET_LAYOUTS:
      return {
        ...state,
        layouts: action.payload.data,
        pages: action.payload.pages,
        llayouts: false
      };
    case LayoutActionTypes.UPDATE_POSITION_LAYOUT:
      return {
        ...state,
        layouts: state.layouts.map(layout => {
          const update = action.payload.find((u: { id: string; position: number }) => u.id === layout._id);
          if (update) {
            return { ...layout, position: update.position };
          }
          return layout;
        })
      };
    case LayoutActionTypes.ERROR_LAYOUTS:
      return { ...state, llayouts: false };
    case LayoutActionTypes.LOADING_LAYOUT:
      return { ...state, llayout: true };
    case LayoutActionTypes.GET_LAYOUT:
      return { ...state, layout: action.payload, llayout: false };
    case LayoutActionTypes.ERROR_LAYOUT:
      return { ...state, llayout: false };
    case LayoutActionTypes.CHANGE_STATE_LAYOUT:
      return { 
        ...state, 
        layout: action.payload, 
        layouts: state.layouts.map(layout => 
          layout._id === action.payload._id ? { ...layout, state: action.payload.state } : layout
        ),
        llayout: false 
      };
    case LayoutActionTypes.REMOVE_LAYOUT:
      return { 
        ...state, 
        layouts: state.layouts.filter(layout => layout._id !== action.payload),
        llayout: false 
      };
    case LayoutActionTypes.CREATE_LAYOUT:
      if (!action.payload) {
        return state;
      }
      
      const layoutExists = state.layouts.some(layout => layout._id === action.payload._id);
      
      const updatedLayouts = layoutExists 
        ? state.layouts.map(layout => layout._id === action.payload._id ? action.payload : layout)
        : [...state.layouts, action.payload];
      
      return { 
        ...state, 
        layouts: updatedLayouts,
        layout: action.payload,
        llayout: false 
      };
    case LayoutActionTypes.UPDATE_LAYOUT:
      if (!action.payload) {
        return state;
      }
      
      return {
        ...state,
        layouts: state.layouts.map(layout => 
          layout._id === action.payload._id ? { ...layout, ...action.payload } : layout
        ),
        layout: action.payload,
        llayout: false
      };
    default:
      return state;
  }
};

export default LayoutsReducer;
